import React from "react";

import close from "./../../../UI/general/close.svg";

interface Props {
  showTooltip: boolean;
  propertiesData: any;
  filteredProperty: any;
  clientX: any;
  clientY: any;
  handleHideTooltip: any;
  handleamenitiesMenySelection: any;
  tooltipIsRigth: any
}

interface State {
  filter: any;
  attributesValues: any;
}

class PropertiesTooltip extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      filter: {},
      attributesValues: {},
    };
  }

  componentDidMount(): void {
    var tempAttributesValuesArray: any = {};
    this.props.propertiesData.attributes.map(
      (attribute: any, index: number) =>
        (tempAttributesValuesArray[attribute.id] = {
          type: attribute.type,
          value: attribute.name,
          parent: attribute.padre,
        })
    );

    this.setState({
      attributesValues: tempAttributesValuesArray,
    });
  }

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>,
    snapshot?: any
  ): void {
    if (
      prevProps.filteredProperty !== this.props.filteredProperty &&
      this.props.filteredProperty !== ""
    ) {
      var filter = this.props.propertiesData.property.filter(
        (property: any) => property.id === this.props.filteredProperty
      );
      this.setState({
        filter: filter[0],
      });
    }
  }

  handleGetTooltipWidth = () => {
    return 360
  }

  render(): React.ReactNode {
    return (
      <div
        className={
          this.props.showTooltip ? "tooltip fade-in" : "tooltip fade-out"
        }
        id = 'tooltip'
        style={{
          left: this.props.tooltipIsRigth ? this.props.clientX - this.handleGetTooltipWidth() + "px" :this.props.clientX + "px",
          top:
            this.props.clientY < window.innerHeight / 2
              ? this.props.clientY + "px"
              : this.props.clientY - 200 + "px",
        }}
      >
        <div
          className="tooltip-close-container"
          onClick={() => {
            this.props.handleHideTooltip();
          }}
        >
          <img src={close} alt=""></img>
        </div>
        {this.state.filter ? (
          <div className="info-apto-container">
            <div className="property-name-tooltip">
              {"Apto " + this.state.filter.property}
            </div>
            <div className="hirarchical-tooltip-container">
              {this.state.filter.values
                ? this.state.filter.values.map(
                    (attribute: any, index: number) =>
                      this.state.attributesValues[attribute.attribute].type ===
                      "Hierarchical" ? (
                        <React.Fragment>
                          {this.state.attributesValues[attribute.attribute]
                            .parent === null ? (
                            <div key={attribute.value + "tooltip-apto" + index}>
                              {attribute.value}
                            </div>
                          ) : this.state.attributesValues[attribute.attribute]
                              .parent !== null ? (
                            <div key={attribute.value + "tooltip-apto" + index}>
                              {" / " + attribute.value}
                            </div>
                          ) : null}
                        </React.Fragment>
                      ) : null
                  )
                : null}
            </div>
            <hr></hr>
            <div className="attribute-values-tooltip">
              {this.state.filter.values
                ? this.state.filter.values.map(
                    (attribute: any, index: number) =>
                      this.state.attributesValues[attribute.attribute].type !==
                      "Hierarchical" ? (
                        <div key={attribute.value + "tooltip" + index}>
                          {this.state.attributesValues[attribute.attribute]
                            .value +
                            ": " +
                            attribute.value}
                        </div>
                      ) : null
                  )
                : null}
            </div>
            {this.state.filter.galleries &&
            this.state.filter.galleries.length > 0 ? (
              <hr></hr>
            ) : null}
            {this.state.filter.galleries &&
            this.state.filter.galleries.length > 0 ? (
              <div className="tooltip-galleries">
                {this.state.filter.galleries.map(
                  (gallery: any, index: number) => (
                    <div
                      className="tooltip-gallery-individual-item"
                      key={"tooltip-gallery" + index}
                      onClick={() => {
                        this.props.handleamenitiesMenySelection(gallery);
                      }}
                    >
                      <img src={gallery.icon} alt="" />
                      <div>{gallery.name}</div>
                    </div>
                  )
                )}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }
}

export default PropertiesTooltip;
